import React, { useEffect, createElement } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { Countdown } from './components/Countdown';
import { Stats } from './components/Stats';
import { Contents } from './components/Contents';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { ExtraContent } from './components/ExtraContent';
import { Pricing } from './components/Pricing';
import { PurchasePopup } from './components/PurchasePopup';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1252242806993118');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1252242806993118&ev=PageView&noscript=1" />`;
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="w-full min-h-screen bg-[#0a0a0a]" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <Hero data-id="element-2" />
      <Countdown data-id="element-3" />
      <Stats data-id="element-4" />
      <Contents data-id="element-5" />
      <Testimonials data-id="element-6" />
      <Bonuses data-id="element-7" />
      <ExtraContent data-id="element-8" />
      <Pricing data-id="element-9" />
      <Footer data-id="element-10" />
      <PurchasePopup data-id="element-11" />
    </div>;
}